import { IHttpClient } from "../IHttpClient";
import { FdaExportQuery, IFdaService } from "./IFdaService";

export class FdaService implements IFdaService {
  private readonly httpclient: IHttpClient;

  constructor(httpclient: IHttpClient) {
    this.httpclient = httpclient;
  }

  getProducts(
    machineId: MachineId,
    startDate: Date,
    endDate: Date
  ): Promise<any> {
    return this.get(
      `v1/fda/${machineId}/product?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    );
  }

  getSupplies(
    machineId: MachineId,
    startDate: Date,
    endDate: Date
  ): Promise<any> {
    return this.get(
      `v1/fda/${machineId}/supply?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    );
  }

  async getFdaExport(
    machineId: MachineId,
    query: FdaExportQuery
  ): Promise<void> {
    const response = await this.postBlob(`v1/fda/${machineId}/export`, {
      startDate: query.startDate.toISOString(),
      endDate: query.endDate.toISOString(),
      product: query.product,
      supply: query.supply,
    });

    if (!(response.data instanceof Blob)) {
      console.error("FdaService.getFdaExport: response is not a Blob");
      return;
    }

    let fileName = response.headers["content-disposition"]
      .split(";")[1]
      .split("filename=")[1]
      .trim();

    const link = document.createElement("a");
    link.href = globalThis.URL.createObjectURL(response.data);
    link.download = fileName;
    link.click();
  }

  private get(url: string, params?: any): Promise<any> {
    this.httpclient.get(url, params);
    return this.httpclient.get(url, params);
  }

  private postBlob(url: string, body: any): Promise<any> {
    return this.httpclient.postBlob(url, body);
  }
}
